import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";

import { actions as topikActions } from "../../../../modules/topik";
import { draftKey } from "../useDraft";
import SingleTextAnalysisStep from "./SingleTextAnalysisStep";
import AnalysisRecall from "./AnalysisRecall";

// Captures the inventive idea only; its win-maximization moved to the continue branch (§6.2a).
// The prompt asks for an idea "that follows from these issues", so the listed issues are carried
// onto the screen (memory-load).
const TopikSolutionView = ({ t, session, topikStatus, gameClosed, dispatch }) => (
  <SingleTextAnalysisStep
    t={t}
    title={t("topik-solution-view.title")}
    instruction={t("topik-solution-view.instruction")}
    placeholder={t("topik-solution-view.solution-placeholder")}
    submitLabel={t("topik-solution-view.submit")}
    initialValue={session.solution || ""}
    draftKey={draftKey(session, "solution")}
    maxLength={session.maxTextLength}
    submitting={topikStatus.submitting}
    gameClosed={gameClosed}
    error={topikStatus.error}
    recall={(
      <AnalysisRecall
        entries={[{ key: "issues", label: t("topik-analysis.recall.issues"), list: session.issues }]}
      />
    )}
    assistStep="solution"
    onBack={() => dispatch(topikActions.analysis.back.request())}
    onSubmit={(solution) => dispatch(topikActions.analysis.solution.request({ solution }))}
  />
);

TopikSolutionView.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  topikStatus: PropTypes.object.isRequired,
  gameClosed: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

TopikSolutionView.defaultProps = {
  gameClosed: false,
};

const mapStateToProps = (state) => ({
  session: state.topik.session,
  topikStatus: state.topik.status,
});

export default compose(withTranslation("views"), connect(mapStateToProps))(TopikSolutionView);
